const controller = function(
	$cordovaImagePicker,
	$ionicScrollDelegate,
	$ionicViewSwitcher,
	$state,
	$ionicHistory,
	$q,
	$scope,
	$stateParams,
	$timeout,
	Support,
) {
	"ngInject"

	var vm = this;
	var bodyBottom;

	vm.messages = [];
	vm.input = '';
	vm.adding = false;
	var init = false;

	vm.hasHistory = $ionicHistory.backView() !== null;

	$scope.$on('chat:received', function(e, message) {
		vm.load();
	});

	vm.back = function() {
		$ionicViewSwitcher.nextDirection('back');
		$ionicHistory.nextViewOptions({
			disableBack: true,
		    historyRoot: true
		});
		if ($ionicHistory.backView()) {
			$ionicHistory.backView().go();
		} else {
			$state.go('tab.more');
		}
	}

	vm.load = function() {
		Support.get().then(function(res) {
			if (init) document.getElementById('messageSound').play();
			vm.adding = false;
			vm.messages = res;
			$ionicScrollDelegate.$getByHandle('support').scrollBottom(init);
			init = true
			Support.setCount(0);
		});
	}

	vm.submit = function() {
		if (vm.input !== '') {
			vm.adding = true;
			Support.send(vm.input);
			vm.input = '';
		}
	}

	vm.update = function(animate) {

		$timeout(function() {
			$ionicScrollDelegate.$getByHandle('support').resize();
			$ionicScrollDelegate.$getByHandle('support').scrollBottom(animate !== undefined ? animate : true);
		}, 10);
		
	}

	vm.upload = () => {
		$cordovaImagePicker.getPictures({
			maximumImagesCount: 1,
			quality: 70
		}).then(res => {
			var promises = [];
			angular.forEach(res, file => {
	        	promises.push(Support.upload(file));
	        });

			return $q.all(promises);
		}).catch(err => {
			console.log(err);
		})
	}

	vm.gotoProduct = (id) => {
		$state.go('tab.product', {
			uid: id,
			ref: 'support'
		});
	}

	window.addEventListener('native.keyboardhide', function(){
		vm.update();
	});

	window.addEventListener('native.keyboardshow', function(){
		vm.update();
	});

	$scope.$on('$ionicView.enter', function(event, data){

		if ($stateParams.product) {
			vm.input = $stateParams.product; 
			$stateParams.product = false;
		}

		if ($stateParams.upload) {
			vm.upload();
			$stateParams.upload = false;
		}
	});

	$scope.$on('$ionicView.loaded', function() {
		vm.load();
	});

}

export default controller;



// WEBPACK FOOTER //
// ./app/components/support/support.controller.js